module.exports = __webpack_public_path__ + "static/media/amigosdanatureza.9c2feee5.png";